import React, { createContext, useContext, useState, useMemo } from "react"
import { getTheme } from "../layouts/Theme"

const ThemeModeContext = createContext()

export function ThemeModeProvider({ children }) {
    const [mode, setMode] = useState(
        localStorage.getItem("themeMode") || "dark"
    )
    const [scheme, setScheme] = useState(
        localStorage.getItem("themeScheme") || "default"
    )

    const theme = useMemo(() => getTheme(mode, scheme), [mode, scheme])

    function toggleTheme() {
        setMode((prev) => {
            const nextMode = prev === "dark" ? "light" : "dark"
            localStorage.setItem("themeMode", nextMode)
            return nextMode
        })
    }

    function changeScheme(newScheme) {
        setScheme(newScheme)
        localStorage.setItem("themeScheme", newScheme)
    }

    return (
        <ThemeModeContext.Provider
            value={{ mode, toggleTheme, theme, scheme, changeScheme }}
        >
            {children}
        </ThemeModeContext.Provider>
    )
}

export function useThemeMode() {
    return useContext(ThemeModeContext)
}
